import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect, useMemo, useState, useCallback, } from 'preact/compat';
import { useController, useFormContext, } from 'react-hook-form';
import defaultNumberFormat from '@widgets/shared/defaultNumberFormat';
import Field from './styles/field';
import Button from './styles/button';
import Input from './styles/control';
function NumberInput(props) {
    const { name: fieldName, bands, band, price, showPrice, accent, } = props;
    const { control, getValues, setValue, } = useFormContext();
    const { field: { value: fieldValue, onChange }, } = useController({
        name: fieldName,
        control,
    });
    const [inputValue, setInputValue] = useState(fieldValue ?? 0);
    const allBands = bands;
    const inputArgs = useMemo(() => ({
        max: band.Maximum ?? 9999,
        min: band.Minimum ?? 0,
        step: band.Multiple ?? 1,
    }), [band]);
    const isPrevButtonUsable = useMemo(() => {
        if (fieldValue <= 0) {
            return true;
        }
        const dependants = allBands.filter((loopBand) => loopBand.AccompaniedId === band.Id);
        let hasDependant = false;
        if (dependants.length) {
            dependants.forEach((dependant) => {
                const dependentCurrentValue = parseInt(getValues(dependant.FieldName), 10);
                const nextPrevValue = fieldValue - band.Multiple;
                hasDependant = (dependentCurrentValue > 0 && (nextPrevValue < band.Minimum || nextPrevValue < 1));
            });
        }
        return hasDependant;
    }, [allBands, band, fieldValue, getValues]);
    const handleInputChange = useCallback((ev) => {
        const newValue = parseInt(ev.currentTarget.value, 10);
        if (newValue >= band.Minimum && newValue <= band.Maximum) {
            setInputValue(newValue);
        }
    }, [band.Maximum, band.Minimum]);
    const handleInputValueChange = useCallback(() => {
        // console.log('Bands: ', allBands);
        if (band.AccompaniedId && inputValue > 0) {
            const accompaniedBand = allBands.find((loopBand) => loopBand.Id === band.AccompaniedId);
            if (accompaniedBand) {
                const accompaniedFieldName = accompaniedBand.FieldName;
                const accompaniedCurrentValue = parseInt(getValues(accompaniedFieldName), 10);
                // console.log('Accomponies field name: ', accompaniedFieldName);
                if (accompaniedCurrentValue < 1 || accompaniedCurrentValue < accompaniedBand.Minimum) {
                    let newAccompaniedValue = accompaniedCurrentValue + accompaniedBand.Multiple;
                    if (newAccompaniedValue > accompaniedBand.Maximum)
                        newAccompaniedValue = accompaniedBand.Maximum;
                    setValue(accompaniedFieldName, newAccompaniedValue, { shouldValidate: false });
                }
            }
        }
        // console.log('Reached here');
        onChange(inputValue);
    }, [allBands, band.AccompaniedId, getValues, inputValue, onChange, setValue]);
    const increase = useCallback(() => {
        const newValue = parseInt(fieldValue, 10) + inputArgs.step;
        if (newValue <= band.Minimum) {
            return setInputValue(band.Minimum);
        }
        if (newValue <= band.Maximum) {
            return setInputValue(fieldValue + inputArgs.step);
        }
        return true;
    }, [band, fieldValue, inputArgs]);
    const decrease = useCallback(() => {
        const newValue = parseInt(fieldValue, 10) - inputArgs.step;
        if ((band.Minimum > 0) && (newValue > 0 && newValue < band.Minimum)) {
            return setInputValue(0);
        }
        if (newValue >= band.Minimum || newValue >= 0) {
            return setInputValue(fieldValue - inputArgs.step);
        }
        return true;
    }, [band, fieldValue, inputArgs]);
    useEffect(() => setInputValue(fieldValue), [fieldValue]);
    useEffect(handleInputValueChange, [inputValue, handleInputValueChange]);
    return (_jsxs(Field.Wrapper, { children: [_jsxs(Button.Element, { isDecrease: true, type: "button", disabled: isPrevButtonUsable, onClick: decrease, children: [_jsx(Button.Label, { children: "Decrease" }), _jsx(Button.Minus, { fill: accent })] }), _jsxs(Input.Wrapper, { children: [_jsx(Input.Element, { type: "number", name: fieldName, value: inputValue, onChange: handleInputChange, ...inputArgs }), (showPrice) && (_jsx(Field.Price, { children: `${defaultNumberFormat.format(price)}` }))] }), _jsxs(Button.Element, { type: "button", onClick: increase, children: [_jsx(Button.Label, { children: "Increase" }), _jsx(Button.Plus, { fill: accent })] })] }));
}
export default NumberInput;
